import { render, staticRenderFns } from "./TwitchAuth.vue?vue&type=template&id=abc02076&scoped=true&"
import script from "./TwitchAuth.vue?vue&type=script&lang=js&"
export * from "./TwitchAuth.vue?vue&type=script&lang=js&"
import style0 from "./TwitchAuth.vue?vue&type=style&index=0&id=abc02076&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc02076",
  null
  
)

export default component.exports